import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspaceAssessmentDetailScreen } from '@/features/assessments/components/workspace/AssessmentDetailScreen';

const searchSchema = z.object({
  tab: z.enum(['overview', 'questions', 'scoring']).optional(),
});

export const Route = createFileRoute('/app/assessments/$templateId/')({
  validateSearch: searchSchema,
  component: Wrap,
});

function Wrap() {
  const { templateId } = useParams({ from: '/app/assessments/$templateId/' });
  const { tab } = useSearch({ from: '/app/assessments/$templateId/' });
  return (
    <WorkspaceAssessmentDetailScreen
      templateId={templateId}
      initialTab={tab ?? 'overview'}
      surface="clinical"
    />
  );
}
